import { SWReactIcons } from "@similarweb/icons";
import { Badge, OnOffSwitch, RadioButton } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import type { Granularity } from "app/pages/activation-alerts/types/PlatformAlerts";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

import { useSubscriptionContext } from "../../../context/Subscription/SubscriptionProvider";

import { newsLeverKeys } from "./dataAutomation";
import * as SC from "./styles";
import { FREQUENCY_TEXT, NEWS_LEVER_RECEIVE_LABEL, NEWS_LEVER_RECEIVE_TOOLTIP } from "./texts";
import { ActivationSubscriptions } from "./types";

interface INewsAlertsProps {
    isSwitchedAlertsNews: boolean;
}

const GRANULARITY_LIST = [GranularityNames.DAILY, GranularityNames.WEEKLY, GranularityNames.MONTHLY];

export const NewsAlerts = ({ isSwitchedAlertsNews }: INewsAlertsProps) => {
    const { isNewsAlertsAvailable, newsAlertsGranularity, onSelect, onSwitch } = useSubscriptionContext();

    const onLeverSwitch = () => onSwitch(!isSwitchedAlertsNews, ActivationSubscriptions.NewsAlerts);

    const onLeverGranularitySelect = (granularity: Granularity) => () =>
        onSelect(granularity, ActivationSubscriptions.NewsAlerts);

    if (!isNewsAlertsAvailable) {
        return null;
    }

    return (
        <Stack>
            <SC.Divider />
            <SC.SwitchWrapper data-automation={newsLeverKeys.switchContainer}>
                <SC.SwitchLabel
                    onClick={onLeverSwitch}
                    data-automation={newsLeverKeys.switchLabel}
                >
                    {translate(NEWS_LEVER_RECEIVE_LABEL)}
                    <SC.BadgeIconWrapper>
                        <SC.StyledTooltip content={translate(NEWS_LEVER_RECEIVE_TOOLTIP)}>
                            <SWReactIcons
                                iconName="info"
                                size="xs"
                            />
                        </SC.StyledTooltip>
                        <SC.BetaBadgeWrapper>
                            <Badge type="beta" />
                        </SC.BetaBadgeWrapper>
                    </SC.BadgeIconWrapper>
                </SC.SwitchLabel>

                <OnOffSwitch
                    onClick={onLeverSwitch}
                    isSelected={isSwitchedAlertsNews}
                />
            </SC.SwitchWrapper>
            <SC.RadioGroupTitle data-automation={newsLeverKeys.radioGroupTitle}>
                {translate(FREQUENCY_TEXT)}
            </SC.RadioGroupTitle>

            <SC.RadioGroup
                data-automation-isDisabled={!isSwitchedAlertsNews}
                data-automation={newsLeverKeys.radioGroupGranularity}
            >
                {GRANULARITY_LIST.map((granularity, id) => (
                    <RadioButton
                        itemDisabled={!isSwitchedAlertsNews}
                        className="emailGranularity"
                        key={id}
                        itemLabel={granularity}
                        onClick={onLeverGranularitySelect(granularity)}
                        itemSelected={granularity === newsAlertsGranularity}
                    />
                ))}
            </SC.RadioGroup>
        </Stack>
    );
};
